import { types } from "mobx-state-tree"
import { DictionaryLink } from "modules/common/models/dictionary-link"

/** Ключи системных колонок. Совпадают с QuestionColumnKeys на бэке */
export const SystemColumns = {
  inWork: "in-work",
  expired: "expired",
  review: "review",
  done: "done",
}

/** В этих колонках задание не заводят: они показывают результат работы, а не её начало */
export const NO_QUICK_ADD: string[] = [SystemColumns.expired, SystemColumns.review, SystemColumns.done]

/** Колонки, которые нельзя удалить и переименовать */
export const SYSTEM_KEYS: string[] = [
  SystemColumns.inWork,
  SystemColumns.expired,
  SystemColumns.review,
  SystemColumns.done,
]

/** В «Просрочено» карточку не перетаскивают: колонка заполняется по сроку задания */
export const isDropDisabled = (columnKey: string) => columnKey === SystemColumns.expired

export const BoardColumn = types
  .model({
    id: types.string,
    boardId: types.optional(types.string, ""),
    systemKey: types.optional(types.string, ""),
    name: types.string,
    color: types.string,
    order: types.number,
    isSystem: types.boolean,
    /** Архивная колонка: карточки в ней копятся и подгружаются кнопкой, а не прокруткой */
    isArchive: types.optional(types.boolean, false),
    key: types.string,
  })
  .views((self) => ({
    /** Можно ли завести задание прямо в колонке */
    get canQuickAdd() {
      return !self.isArchive && NO_QUICK_ADD.indexOf(self.systemKey) < 0
    },
  }))
  .named("BoardColumn")

export const QuestionTag = types
  .model({
    id: types.optional(types.string, ""),
    name: types.string,
    color: types.string,
  })
  .named("QuestionTag")

export const Portfolio = types
  .model({
    id: types.string,
    name: types.string,
    color: types.string,
    created: types.optional(types.string, ""),
    owner: types.maybeNull(DictionaryLink),
    members: types.array(DictionaryLink),
    order: types.optional(types.number, 0),
    canManage: types.optional(types.boolean, false),
    questionsCount: types.optional(types.number, 0),
  })
  .named("Portfolio")

export type BoardColumnType = typeof BoardColumn.Type
export type BoardColumnSnapshotType = typeof BoardColumn.SnapshotType
export type QuestionTagType = typeof QuestionTag.Type
export type QuestionTagSnapshotType = typeof QuestionTag.SnapshotType
export type PortfolioType = typeof Portfolio.Type
export type PortfolioSnapshotType = typeof Portfolio.SnapshotType

/** Ответ /orders/question-board */
export interface QuestionBoardSnapshot {
  boardEnabled: boolean
  customColumnsEnabled: boolean
  portfoliosEnabled: boolean
  canCreatePortfolio: boolean
  canManageColumns: boolean
  columns: BoardColumnSnapshotType[]
  portfolios: PortfolioSnapshotType[]
  tags: QuestionTagSnapshotType[]
}

export interface SaveColumn {
  id: string
  systemKey: string
  name: string
  color: string
  isArchive: boolean
}

/** Цвет метки по умолчанию. Совпадает с QuestionTag.DefaultColor на бэке */
export const DEFAULT_TAG_COLOR = "#4b5a66"

/** Палитра для пользовательских колонок, портфелей и меток — из фирменной темы planr */
export const COLUMN_COLORS = [
  "#36acd7",
  "#1dd278",
  "#eab308",
  "#e31818",
  "#7d36d7",
  "#ea561e",
  "#00273d",
  "#6b7a87",
]
